module.exports = __webpack_public_path__ + "static/storia_3_small-280ed71f1a4fea41989aea6a5e1a6880.jpg";